<template>
  <div class="org-transfer-detail-page">
    <SubPageHeader title="组织转接" />
    <div class="content">
      <div v-if="isLoading" class="state-text">加载中...</div>
      <div v-else-if="transferList.length === 0" class="state-text">暂无组织转接数据</div>
      <div v-else class="list">
        <div
          v-for="(item, index) in transferList"
          :key="item.id || item.transfer_id || item.org_transfer_id || index"
          class="transfer-card"
        >
          <div class="card-main">
            <div class="card-row">
              <span class="label">转接类型：</span>
              <span class="value">{{ getTransferType(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">申请人：</span>
              <span class="value">{{ getApplicantName(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">手机号：</span>
              <span class="value">{{ getApplicantMobile(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">转出组织：</span>
              <span class="value">{{ getFromOrg(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">接收组织：</span>
              <span class="value">{{ getToOrg(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">转接状态：</span>
              <span :class="['status-tag', getTransferStatusClass(item)]">{{ getTransferStatus(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">审核状态：</span>
              <span :class="['status-tag', getAuditStatusClass(item)]">{{ getAuditStatus(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">接收状态：</span>
              <span :class="['status-tag', getReceiveStatusClass(item)]">{{ getReceiveStatus(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">申请时间：</span>
              <span class="value">{{ getCreatedAt(item) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrgTransferList } from '@/api';
import SubPageHeader from '../component/SubPageHeader.vue';

const FETCH_PAGE_SIZE = 50;
const MAX_FETCH_ROUNDS = 100;

export default {
  name: 'OrgTransferDetailPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      isLoading: false,
      transferList: []
    };
  },
  mounted() {
    this.fetchTransferList();
  },
  methods: {
    normalizeList(payload) {
      if (Array.isArray(payload)) {
        return payload;
      }
      if (Array.isArray(payload?.list)) {
        return payload.list;
      }
      if (Array.isArray(payload?.rows)) {
        return payload.rows;
      }
      return [];
    },
    async fetchTransferList() {
      this.isLoading = true;
      try {
        const allList = [];
        let currentPage = 1;
        let total = Infinity;
        let rounds = 0;

        while (allList.length < total && rounds < MAX_FETCH_ROUNDS) {
          const res = await getOrgTransferList({
            page: currentPage,
            pageSize: FETCH_PAGE_SIZE
          });
          const payload = res?.data || {};
          const currentList = this.normalizeList(payload);
          const payloadTotal = Number(payload?.total);
          if (Number.isFinite(payloadTotal) && payloadTotal >= 0) {
            total = payloadTotal;
          }
          allList.push(...currentList);
          if (currentList.length < FETCH_PAGE_SIZE) {
            break;
          }
          currentPage += 1;
          rounds += 1;
        }

        this.transferList = allList;
      } catch (error) {
        this.transferList = [];
      } finally {
        this.isLoading = false;
      }
    },
    getTransferType(item) {
      return item?.typeText || item?.type_text || item?.type || '--';
    },
    getApplicantName(item) {
      return item?.realName || item?.real_name || item?.user_name || '--';
    },
    getApplicantMobile(item) {
      return item?.mobile || item?.phone || '--';
    },
    getFromOrg(item) {
      return item?.from || item?.fromOrgName || item?.from_org_name || '--';
    },
    getToOrg(item) {
      return item?.to || item?.toOrgName || item?.to_org_name || '--';
    },
    getCreatedAt(item) {
      return item?.createdAt || item?.created_at || item?.apply_time || '--';
    },
    getTransferStatus(item) {
      return item?.statusText || item?.status_text || item?.status || '--';
    },
    getAuditStatus(item) {
      return item?.auditStatusText || item?.audit_status_text || item?.auditStatus || item?.audit_status || '--';
    },
    getReceiveStatus(item) {
      return item?.receiveStatusText || item?.receive_status_text || item?.receiveStatus || item?.receive_status || '--';
    },
    isPendingText(text) {
      return /待|等待|审核中|进行中/.test(String(text));
    },
    isSuccessText(text) {
      return /通过|完成|成功|已接收|接收成功/.test(String(text));
    },
    isRejectedText(text) {
      return /驳回|拒绝|失败|退回/.test(String(text));
    },
    getStatusClassByText(text) {
      if (this.isRejectedText(text)) {
        return 'status-danger';
      }
      if (this.isSuccessText(text)) {
        return 'status-success';
      }
      if (this.isPendingText(text)) {
        return 'status-warning';
      }
      return 'status-default';
    },
    getTransferStatusClass(item) {
      return this.getStatusClassByText(this.getTransferStatus(item));
    },
    getAuditStatusClass(item) {
      return this.getStatusClassByText(this.getAuditStatus(item));
    },
    getReceiveStatusClass(item) {
      return this.getStatusClassByText(this.getReceiveStatus(item));
    }
  }
};
</script>

<style scoped lang="scss">
.org-transfer-detail-page {
  min-height: 100vh;
  background: #ffffff;
}

.content {
  padding: 3.58974vw 3.58974vw 5.12821vw;
}

.state-text {
  padding: 10.25641vw 0;
  text-align: center;
  color: #999;
  font-size: 3.84615vw;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 3.07692vw;
}

.transfer-card {
  position: relative;
  background: #ffffff;
  border-radius: 3.58974vw;
  padding: 4.10256vw 3.58974vw 3.58974vw;
  box-shadow: 0 1.4vw 4.2vw rgba(174, 49, 49, 0.12);
  border: 0.25641vw solid #ffe3e3;
}

.card-main {
  min-width: 0;
}

.card-row {
  margin-top: 1.53846vw;
  display: flex;
  align-items: flex-start;
  font-size: 3.48718vw;
  line-height: 1.5;
}

.card-row:first-child {
  margin-top: 0;
}

.label {
  width: 18vw;
  flex-shrink: 0;
  color: #a48484;
}

.value {
  color: #3d2a2a;
  font-weight: 500;
  word-break: break-all;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 14.87179vw;
  height: 6.15385vw;
  padding: 0 2.30769vw;
  border-radius: 3.07692vw;
  font-size: 3.07692vw;
  font-weight: 600;
  line-height: 1;
  border: 0.25641vw solid transparent;
}

.status-success {
  color: #2f955d;
  background: #ecf9f1;
  border-color: #b8e3c9;
}

.status-warning {
  color: #be7b13;
  background: #fff6e6;
  border-color: #f4d4a0;
}

.status-danger {
  color: #d64545;
  background: #fff1f1;
  border-color: #f4b3b3;
}

.status-default {
  color: #6a7282;
  background: #f4f6fa;
  border-color: #e3e8f2;
}
</style>
